// Connect-RPC 전송 — 화면이 MVP API 의 RPC 서비스를 부를 때 쓴다 (api/internal/hellorpc 견본, proto/).
// 부르는 시점의 세션 토큰을 Authorization 에 싣는다 — 로그인 안 했으면 싣지 않고, 서버의 공개 메서드는 그대로 답한다.
// 쓰는 법: createClient(HelloService, rpcTransport()) — HelloService 는 src/gen/… 의 생성물
import type { Interceptor, Transport } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';

import { sessionStore } from './session';

/** 배포에서는 Vercel rewrite 가, 로컬에서는 vite 프록시가 /api/* 를 MVP API 로 넘긴다 */
const API_BASE = '/api';

const withSession: Interceptor = next => request => {
  const session = sessionStore.get();
  if (session) request.header.set('Authorization', `Bearer ${session.token}`);
  return next(request);
};

export function rpcTransport(baseUrl: string = API_BASE): Transport {
  return createConnectTransport({ baseUrl, interceptors: [withSession] });
}
